<template>
<div class="modal-backdrop modal d-block" v-if="is_open" @mousedown.self="this.modal_store.pre_close_modal" @mouseup.self="this.modal_store.do_close_modal">
	<div class="modal-dialog">
		<div class="modal-content">
			<div class="modal-header">
				<h5 class="modal-title">Filter {{ column_store.get_column_name(column_store.get_edit_filter_column.id) }}</h5>
				<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" @click="this.modal_store.close_modal"></button>
			</div>
			<div class="modal-body">
				<div class="row">
					<div class="col-12">
						<FilterColumnEdit v-if="column_store.edit_filter_column_id > 0" :column="column_store.get_edit_filter_column" />
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
</template>

<script>

import { use_modal_store } from '@/stores/modal.js'
import { use_column_store } from '@/stores/column.js'
import FilterColumnEdit from '@/components/FilterColumnEdit.vue'

export default {
	name: 'FilterColumnModal',
	components: {
		FilterColumnEdit,
	},
	setup() {

		let modal_store = use_modal_store()
		let column_store = use_column_store()

		return {
			modal_store,
			column_store,
		}
	},
	data() {
		return {
		}
	},
	computed: {
		is_open() {
			return this.modal_store.current_modal == "filter_column"
		}
	},
	methods: {
	}
}
</script>

<style scoped>
.modal-backdrop {
	background: rgba(0, 0, 0, 0.15);
}
</style>
